/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("NoFilterVMBehavior", ["BehaviorBase"], function (context, cls) {
  /**
   * @class NoFilterVMBehavior
   * @memberOf classes
   * @extends classes.BehaviorBase
   */
  cls.NoFilterVMBehavior = context.oo.Singleton(cls.BehaviorBase, function ($super) {
    return /** @lends classes.NoFilterVMBehavior.prototype */ {
      __name: "NoFilterVMBehavior",

      watchedAttributes: {
        anchor: ["noFilter"]
      },

      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        if (!controller.showReduceFilter) {
          return;
        }

        const widget = controller.getWidget();
        if (!widget) {
          return;
        }

        // Display reduce filter only if widget has the focus
        if (widget.hasFocus()) {
          controller.showReduceFilter();
        }
      }
    };
  });
});
